// TODO: change the brand part, reduce it when height is too small to render everything...

<i18n>
{
    "en_US": {
        "all-rights": "© 2018. All RIGHT RESERVED.",
        "catch-phrase": "To the moon",
        "logo-by": "Logo by"
    },
    "fr_FR": {
        "all-rights": "© 2018. TOUS DROITS RÉSERVÉS.",
        "catch-phrase": "Direction la Lune",
        "logo-by": "Logo réalisé par "
    }
}
</i18n>

<template>
    <div class="blue-background vertical-align text-center">
        <dropdown-language-selector />
        <div class="vertical-align-middle">
            <div class="panel">
                <div class="brand">
                    <img src="/images/favicon/192x192.png" alt="BoogFoo logo" />
                    <h4><cite v-text="$t('catch-phrase')"></cite></h4>
                </div>

                <router-view>
                    <div slot="flashes">
                        <flash-basic />
                    </div>
                </router-view>
            </div>
            <p class="login-footer">
                {{$t("all-rights")}}<br>
                <small>{{$t("logo-by")}} <a class="white" href="https://www.vecteezy.com" target="_blank">Vecteezy</a>.</small>
            </p>
        </div>
    </div>
</template>

<script>
    import DropdownLanguageSelector from "dropdowns/LanguageSelector";
    import FlashBasic from "flashes/Basic";

    export default {
        name: "Unlogged",
        components: {
            DropdownLanguageSelector,
            FlashBasic
        }
    }
</script>

<style scoped>
    .panel {
        margin: auto;
        padding: 20px 40px 40px 40px;
        width: 400px;
        margin-bottom: 45px;
        background: #fff;
        border-radius: .286rem;
    }
    .href {
        color: #3e8ef7;
        font-weight: 100;
        font-size: 14px;
        cursor: pointer;
    }
    .alert {
        text-align: left;
    }
    p.login-footer, p.login-footer a {
        font-size: 12px;
        color: #fff;
        letter-spacing: 1px;
    }
    p.login-footer small, p.login-footer a {
        font-size: 9px;
    }

    .brand img {
        -webkit-transition: all .2s ease;
        -moz-transition: all .2s ease;
        -ms-transition: all .2s ease;
        transition: all .2s ease;
    }

    @media screen and (max-height: 800px) {
        .brand img {
            max-height: 150px;
        }
    }
    @media screen and (max-height: 700px) {
        .brand img {
            max-height: 125px;
        }
    }
    @media screen and (max-height: 650px) {
        .brand img {
            max-height: 75px;
        }
    }
    @media screen and (max-height: 600px) {
        .brand {
            display: none;
        }
    }

    @media screen and (max-width: 700px) {
        .vertical-align-middle {
            width: 100%;
        }
        .blue-background {
            background-image: none !important;
            background: #fff !important;
        }
        .panel {
            margin: 0;
            padding: 10px 20px 20px 20px;
            width: 100%;
            margin-bottom: 25px;
            border-radius: 0;
        }
        p.login-footer, p.login-footer a {
            display: none;
        }
    }
</style>

<style>
    /* Cite style */
    cite {
        margin-top: 1em;
        margin-left: -1em;
        font-size: 0.9em;
        color: #405059;
        -webkit-transition: font-size .2s ease;
        -moz-transition: font-size .2s ease;
        -ms-transition: font-size .2s ease;
        transition: font-size .2s ease;
    }
    cite:before, cite:after {
        color: #405059;
        font-size: 3.5em;
        line-height: 0.1em;
        font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
        -webkit-transition: font-size .2s ease;
        -moz-transition: font-size .2s ease;
        -ms-transition: font-size .2s ease;
        transition: font-size .2s ease;
    }
    cite:before {
        content: open-quote;
        margin-right: 0.25em;
        vertical-align: -0.3em;
    }
    cite:after {
        content: close-quote;
        margin-left: 0.10em;
        vertical-align: -0.75em;
    }

    @media screen and (max-height: 700px) {
        cite {
            font-size: 0.8em;
        }
        cite:before, cite:after {
            font-size: 3em;
        }
    }
    @media screen and (max-height: 650px) {
        cite {
            font-size: 0.7em;
        }
        cite:before, cite:after {
            font-size: 2em;
        }
    }
</style>